module.exports = __webpack_public_path__ + "img/01.9eb9cd2a.jpg";